<!--
 * @Author: Jack jack-lo@foxmail.com
 * @Date: 2023-10-16 18:04:45
 * @LastEditors: Jack jack-lo@foxmail.com
 * @LastEditTime: 2023-10-17 17:01:24
-->
<template>
  <span></span>
</template>

<script>
import coordtransform from 'coordtransform';
import BMapLoader from '../utils/BMapLoader';

export default {
  async mounted() {
    const BMapGL = await BMapLoader.load({
      ak: 'kuwwhpOxIGifzaQ1qyMr2ewcFltLZ3iz',
    });
    console.log(BMapGL);
    const geo = new BMapGL.Geolocation();
    geo.getCurrentPosition((r) => {
      if (geo.getStatus() === window.BMAP_STATUS_SUCCESS) {
        const { lng, lat } = r.point;
        console.log('您的位置：', lng, lat, coordtransform.bd09togcj02(lng, lat));
      } else {
        console.log('failed', geo.getStatus());
      }
    });
  },
};
</script>
